import { set, get, remove } from 'lib/util/localStorage';
import { PREAUTH_LOCALSTORAGE_KEY } from 'constants';

export const PREAUTH_MAX_LENGTH = 5;

export function getResources() {
    const resources = get(PREAUTH_LOCALSTORAGE_KEY);
    return resources;
}

// expiration in days
export function setResources(resources, expiration = 1) {
    set(PREAUTH_LOCALSTORAGE_KEY, resources, expiration * 60 * 60 * 24);
}

export function clear() {
    remove(PREAUTH_LOCALSTORAGE_KEY);
}

export default {
    PREAUTH_MAX_LENGTH,
    getResources,
    setResources,
    clear
};



// WEBPACK FOOTER //
// ./app/lib/auth/PreAuthZ.js